export const STATIC_PATH = '/static/translations/';
export const ASSETS_PATH = '/assets/translations/';
export const DICTIONARY_KEY = 'dictionaryKey';
export const LANGUAGE_KEY = 'languageKey';
